import { StrictMode } from "react";
import ReactDOM from "react-dom/client";

import App from "./App";
import "./app.css";

const rootElement = document.getElementById("app") as HTMLElement;
const root = ReactDOM.createRoot(rootElement);

root.render(
  <StrictMode>
    <App />
  </StrictMode>,
);
